import React, { Dispatch } from 'react';

export type IOnboardingMintMappingContextProps = {
  accountSet?: string[];
  categorySet?: string[];
  importing?: boolean;
  accounts?: { name: string; forBudget: boolean }[];
  setAccounts?: Dispatch<any>;
  setCategoryGroups?: Dispatch<any>;
  categoryGroups?: {
    name: string;
    categories: string[];
  }[];
};

export const OnboardingMintMappingContext: React.Context<IOnboardingMintMappingContextProps> =
  React.createContext({});
